var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99968 3.33332L4.66635 1.99999M0.833008 7.16666L1.96113 7.04131C2.09896 7.026 2.16788 7.01834 2.23229 6.99749C2.28944 6.97898 2.34382 6.95285 2.39397 6.91978C2.45049 6.88251 2.49952 6.83347 2.59758 6.73541L6.99968 2.33332C7.36787 1.96513 7.36787 1.36818 6.99968 0.999989C6.63149 0.631799 6.03454 0.631799 5.66635 0.999988L1.26425 5.40208C1.16619 5.50014 1.11716 5.54917 1.07989 5.60569C1.04682 5.65584 1.02068 5.71023 1.00218 5.76737C0.981326 5.83179 0.973669 5.9007 0.958355 6.03853L0.833008 7.16666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditChat);
export default __webpack_public_path__ + "static/media/editChat.fe0ee5ea4bc12e1d04667edb51127533.svg";
export { ForwardRef as ReactComponent };